module.exports = __webpack_public_path__ + "static/media/dp-logo-video-poster.b824c452.png";